import React from 'react';
import Header from '../Home/Header';
import Footer from '../Home/Footer';
import Whoweare2 from './AboutWhoweare';
import AboutWhoweare2 from './AboutWhoweare2';

const Whoweare = () => {
  return (
    <>
      <Header />
      <Whoweare2 />
      <AboutWhoweare2 />
      <Footer />
    </>
  );
};

export default Whoweare;

